<template>
  <MetricTile
    :loading="loading"
    :no-data="!metric"
    :options="{showAdditionalData: true}"
    icon="fa-solid fa-user-graduate"
    color="amber"
  >
    <template #title>{{ $t("components.UsersHasSelectedSchoolSubjectsMetricTile.title")}}</template>
    <template #metric-title>{{ $t("components.UsersHasSelectedSchoolSubjectsMetricTile.metricTitle") }}</template>
    <template #metric>{{ metric.completed }}</template>
    <template #overMetric>{{ metric.total }}</template>
    <template #additionalMetric> {{ metric.percentage }}%</template>
    <template #info>{{ $t("components.UsersHasSelectedSchoolSubjectsMetricTile.info") }}</template>
  </MetricTile>
</template>

<script setup lang="ts">
import MetricTile from "@/components/Metrics/MetricTile.vue";
import {useMetricTile} from "@/composables/useMetricTile";
const { metric, loading } = useMetricTile<{
  completed: number;
  total: number;
  percentage: number;
}>("subject-choice-usage-ratio");
</script>

<style scoped>

</style>
